import { render, staticRenderFns } from "./approval-container.vue?vue&type=template&id=9c9d9688"
import script from "./approval-container.vue?vue&type=script&lang=js"
export * from "./approval-container.vue?vue&type=script&lang=js"
import style0 from "./approval-container.vue?vue&type=style&index=0&id=9c9d9688&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports